import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateInteractionCommentRequest,
  InteractionComment,
  UpdateInteractionCommentRequest,
} from '@app/models';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseServiceClass } from './baseService.service';

@Injectable({
  providedIn: 'root',
})
export class InteractionCommentService extends BaseServiceClass<InteractionComment> {
  constructor(private http: HttpClient) {
    super(http, '/api/v3/interactions');
    this.entity_url = environment.apiUrl + '/api/v3/interactions';
  }

  /**
   * Lista todos os comentários de uma interação (públicos + privados do usuário logado)
   */
  getInteractionComments(
    interactionId: number
  ): Observable<InteractionComment[]> {
    return this.http.get<InteractionComment[]>(
      `${this.entity_url}/${interactionId}/comments`
    );
  }

  /**
   * Cria um novo comentário para uma interação
   */
  createInteractionComment(
    interactionId: number,
    request: CreateInteractionCommentRequest
  ): Observable<InteractionComment> {
    return this.http.post<InteractionComment>(
      `${this.entity_url}/${interactionId}/comments`,
      request
    );
  }

  /**
   * Atualiza um comentário existente (apenas o autor pode editar)
   */
  updateInteractionComment(
    interactionId: number,
    commentId: number,
    request: UpdateInteractionCommentRequest
  ): Observable<InteractionComment> {
    return this.http.put<InteractionComment>(
      `${this.entity_url}/${interactionId}/comments/${commentId}`,
      request
    );
  }

  /**
   * Remove um comentário (apenas o autor ou administrador pode deletar)
   */
  deleteInteractionComment(
    interactionId: number,
    commentId: number
  ): Observable<void> {
    return this.http.delete<void>(
      `${this.entity_url}/${interactionId}/comments/${commentId}`
    );
  }
}
